import { match } from 'ts-pattern'

import { BlendEventType } from '../api/events/types'

export function getBlendEventMessage(blendEventType: BlendEventType): string {
  return match(blendEventType)
    .with(BlendEventType.INITIALIZED_MODAL, () => 'Modal initialized')
    .with(BlendEventType.CLOSED_MODAL, () => 'Modal closed')
    .with(BlendEventType.CONNECTED_ACCOUNT, () => 'Connected account')
    .with(BlendEventType.INTERNAL_ERROR, () => 'Internal error')
    .with(BlendEventType.LOGIN_ERROR, () => 'Login error')
    .with(BlendEventType.MODAL_INITIALIZATION_ERROR, () => 'Modal initialization error')
    .exhaustive()
}
